/* eslint-disable no-console */

import { Logger, LogMetadata } from './Logger';

export class ConsoleLogger implements Logger {
  private readonly app: string;

  private defaultMetadata: LogMetadata;

  constructor({ app }: { app: string }) {
    this.app = app;
    this.defaultMetadata = {};
  }

  private buildMessage(level: string, message: string) {
    return `[Logger - ${this.app}] [${level}] ${message}`;
  }

  debug(message: string, metadata?: LogMetadata): void {
    console.debug(this.buildMessage('debug', message), {
      ...this.defaultMetadata,
      ...metadata,
    });
  }

  error(message: string, metadata?: LogMetadata): void {
    console.error(this.buildMessage('error', message), {
      ...this.defaultMetadata,
      ...metadata,
    });
  }

  info(message: string, metadata?: LogMetadata): void {
    console.log(this.buildMessage('info', message), {
      ...this.defaultMetadata,
      ...metadata,
    });
  }

  warn(message: string, metadata?: LogMetadata): void {
    console.warn(this.buildMessage('warn', message), {
      ...this.defaultMetadata,
      ...metadata,
    });
  }

  setDefaultMetadata(metadata: LogMetadata): void {
    this.defaultMetadata = metadata;
  }
}

export const createConsoleLogger = ({ app }: { app: string }) => {
  return new ConsoleLogger({ app });
};
